import { Snackbar } from "@sopheos/orbjs_snackbar";

/**
 * @extends Snackbar
 */
class AgendaSnackbar extends Snackbar {
    // Types
    TYPE_ERROR = 1;
    // Keys
    LOGOUT = 1;
    ERROR = 2;
    NOTICE = 4;
}

// current
window.useSnackbar = new AgendaSnackbar((options) => {
    const snack = document.querySelector(`#snackbar`);

    if (snack) {
        snack.dataset.state = options.type;

        const text = snack.querySelector("[data-text]");
        text.innerText = options.message;

        const action = snack.querySelector("[data-action]");
        if (options.action) {
            action.setAttribute("aria-label", options.action);
            action.innerText = options.action;
            action.classList.add("inline-block");
            action.classList.remove("hidden");
        } else {
            action.classList.add("hidden");
            action.classList.remove("inline-block");
        }

        const close = snack.querySelector("[data-close]");
        if (options.close) {
            close.classList.add("inline-block");
            close.classList.remove("hidden");
        } else {
            close.classList.add("hidden");
            close.classList.remove("inline-block");
        }

        snack.dataset.open = options.open;
    }
});
